export default class DtoCaptureAlimArea {
    constructor(obj) {
        this.idAAC = obj.idAAC
        this.name = obj.name
        this.description = obj.description
    }
}